import { useSuspenseQuery } from '@tanstack/react-query'
import { useEffect, useMemo } from 'react'
import { useConfig } from 'wagmi'

import { aaveDataLayer } from './aave-data-layer/query'
import { MarketInfo, marketInfoSelectFn } from './marketInfo'
import { useMarketInfoWethPriceStore } from '@/domain/state/market-info-weth-price'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { useConnectedAddress } from '@/domain/wallet/useConnectedAddress'
import { SuspenseQueryWith } from '@/utils/types'

export interface UseMarketInfoParams {
  chainId: number
  timeAdvance?: number
}
export type UseMarketInfoResultOnSuccess = SuspenseQueryWith<{
  marketInfo: MarketInfo
}>

export function useMarketInfo({ chainId, timeAdvance }: UseMarketInfoParams): UseMarketInfoResultOnSuccess {
  const { account } = useConnectedAddress({ throwOnNotConnected: false })
  const wagmiConfig = useConfig()
  const setStoredWethPrice = useMarketInfoWethPriceStore((state) => state.setWethPrice)

  const res = useSuspenseQuery({
    ...aaveDataLayer({
      wagmiConfig,
      chainId,
      account,
    }),
    select: useMemo(() => marketInfoSelectFn({ timeAdvance }), [timeAdvance]),
  })

  useEffect(() => {
    if (res.data) {
      const weth = res.data.findBySymbol(TokenSymbol('WETH'))
      setStoredWethPrice(weth?.unitPriceUsd)
    }
  }, [res.data, setStoredWethPrice])

  return {
    ...res,
    marketInfo: res.data,
  }
}
